import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import broadcast from './broadcast/reducer_broadcast';
import availability from './broadcast/reducer_availability';
import report_broadcast from './broadcast/reducer_report_broadcast';
import accountManagement from './reducer_account_management';
import geoIPRedcuer from './reducer_geoip';
import deviceInfoReducer from './reducer_device_info';
import broadcasterRegisterReducer from './broadcaster/register';
import broadcasterVerifyOTPReducer from './broadcaster/verify_otp';
import broadcasterResendOTPReducer from './broadcaster/resend_otp';
import broadcaster_followers from './broadcaster/followers';
import broadcaster_favourites from './broadcaster/favourites';
import broadcaster_send_message from './broadcaster/message';
import broadcaster_block_unblock_viewer from './broadcaster/block';
import broadcasterChangeMobileNumberReducer from './broadcaster/change_mobile_number';
import predefinedTags from './broadcaster/predefined_tags';
import broadcasterChannelPicture from './broadcaster/channel_picture';
import broadcasterProfilePicture from './broadcaster/profile_pic';
import broadcasterProfile from './broadcaster/profile';
import notificationDataList from './reducer_notifications_list'
import leftBar from './reducer_leftbar'
import flag from './reducer_flag'
import searchbar from './reducer_searchbar'
import following from './reducer_follow'
import broadcaster_detail_management from './reducer_broadcaster_detail_management'
import broadcaster_get_my_earnings from './broadcaster/get_my_earnings'
import tokbox from './broadcast/tokbox'
import get_broadcast_earnings from './broadcast/reducer_get_broadcast_earnings'
import join_broadcast from './broadcast/reducer_join_broadcast'
import moneyblox_reducer from './moneyblox_reducer'
import charge_Viewer from './reducer_charge_viewer'
import profanity from './reducer_profanity'
import tip from './reducer_tip'
import reducer_get_my_library from './clipstore/broadcaster/reducer_get_my_library'
import reducer_delete_videos from './clipstore/broadcaster/reducer_delete_videos'
import reducer_duplicate_videos from './clipstore/broadcaster/reducer_duplicate_videos'
import reducer_publish_videos from './clipstore/broadcaster/reducer_publish_videos'
import reducer_retry_video_url from './clipstore/broadcaster/reducer_retry_video_url'
import reducer_upload_video_content from './clipstore/broadcaster/reducer_upload_video_content'
import reducer_add_video_to_library from './clipstore/broadcaster/reducer_add_video_to_library'
import reducer_edit_video_to_gallery from './clipstore/broadcaster/reducer_edit_video_to_gallery'
import reducer_get_my_gallery from './clipstore/broadcaster/reducer_get_my_gallery'
import reducer_add_edit_pricing from './clipstore/broadcaster/reducer_add_edit_pricing'
import reducer_add_edit_pricing_content from './clipstore/broadcaster/reducer_add_edit_pricing_content'
import reducer_add_video_to_gallery from './clipstore/broadcaster/reducer_add_video_to_gallery'

import reducer_add_gallery from './clipstore/broadcaster/gallery/reducer_add_gallery'
import reducer_edit_gallery from './clipstore/broadcaster/gallery/reducer_edit_gallery'
import reducer_delete_gallery from './clipstore/broadcaster/gallery/reducer_delete_gallery'

import reducer_get_content_list from './clipstore/user/reducer_get_content_list'
import reducer_get_picture_details from './clipstore/user/reducer_get_picture_details'
import reducer_get_video_details from './clipstore/user/reducer_get_video_details'
import reducer_get_gallery_details from './clipstore/user/reducer_get_gallery_details'

import reducer_purchase_content from './clipstore/user/reducer_purchase_content'
import reducer_subscribe_to_broadcaster from './clipstore/user/reducer_subscribe_to_broadcaster'

import reducer_get_subscription_list from './clipstore/user/subscription/reducer_get_subscription_list'
import reducer_cancel_subscription from './clipstore/user/subscription/reducer_cancel_subscription'
import reducer_renew_subscription from './clipstore/user/subscription/reducer_renew_subscription'

import reducer_get_my_subscribers from './clipstore/broadcaster/subscription/reducer_get_my_subscribers'
import reducer_get_my_subscription from './clipstore/broadcaster/subscription/reducer_get_my_subscription'
import reducer_update_my_subscription from './clipstore/broadcaster/subscription/reducer_update_my_subscription'

import reducer_get_all_users from './messaging/broadcaster/get_all_users'
import reducer_post_content_in_chat from './messaging/broadcaster/post_content_in_chat'
import reducer_get_chat_post from './messaging/broadcaster/get_chat_post'
import reducer_buy_chat_post_content from './messaging/user/buy_chat_post_content'
import reducer_user_profile from './user/profile'
import reducer_user_following from './user/following'

//comment
import reducer_get_comments from './clipstore/user/comment/reducer_get_comments'
import reducer_create_comment from './clipstore/user/comment/reducer_create_comment'
import reducer_update_comment from './clipstore/user/comment/reducer_update_comment'
import reducer_delete_comment from './clipstore/user/comment/reducer_delete_comment'

//reply
import reducer_create_reply from './clipstore/user/reply/reducer_create_reply'
import reducer_delete_reply from './clipstore/user/reply/reducer_delete_reply'
import reducer_get_reply from './clipstore/user/reply/reducer_get_reply'
import reducer_update_reply from './clipstore/user/reply/reducer_update_reply'

const rootReducer = combineReducers({
    account_management: accountManagement,
    geoip: geoIPRedcuer,
    device: deviceInfoReducer,
    broadcaster_register: broadcasterRegisterReducer,
    broadcaster_verify_otp: broadcasterVerifyOTPReducer,
    broadcaster_resend_otp: broadcasterResendOTPReducer,
    broadcaster_change_mobile_number: broadcasterChangeMobileNumberReducer,
    broadcaster_followers: broadcaster_followers,
    broadcaster_favourites: broadcaster_favourites,
    broadcaster_send_message: broadcaster_send_message,
    broadcaster_block_unblock_viewer: broadcaster_block_unblock_viewer,
    predefinedTags: predefinedTags,
    broadcasterProfile: broadcasterProfile,
    broadcasterProfilePicture:broadcasterProfilePicture,
    broadcasterChannelPicture: broadcasterChannelPicture,
    notificationDataList: notificationDataList,
    leftBar: leftBar,
    flag: flag,
    searchbar: searchbar,
    broadcast: broadcast,
    availability: availability,
    report_broadcast:report_broadcast,
    broadcaster_get_my_earnings:broadcaster_get_my_earnings,
    tokbox: tokbox,
    get_broadcast_earnings: get_broadcast_earnings,
    join_broadcast: join_broadcast,
    following: following,
    broadcaster_detail_management: broadcaster_detail_management,
    moneyblox: moneyblox_reducer,
    charge_Viewer: charge_Viewer,
    profanity: profanity,
    tip:tip,
    clipstore_broadcaster_get_my_library:reducer_get_my_library,
    clipstore_broadcaster_delete_videos:reducer_delete_videos,
    clipstore_broadcaster_duplicate_videos:reducer_duplicate_videos,
    clipstore_broadcaster_publish_videos:reducer_publish_videos,
    clipstore_broadcaster_retry_video_url:reducer_retry_video_url,
    clipstore_broadcaster_upload_video_content:reducer_upload_video_content,
    clipstore_broadcaster_add_video_to_library:reducer_add_video_to_library,
    clipstore_broadcaster_edit_video_to_gallery:reducer_edit_video_to_gallery,
    clipstore_broadcaster_get_my_gallery:reducer_get_my_gallery,
    clipstore_broadcaster_add_edit_pricing:reducer_add_edit_pricing,
    clipstore_broadcaster_add_edit_pricing_content:reducer_add_edit_pricing_content,
    clipstore_broadcaster_reducer_add_video_to_gallery:reducer_add_video_to_gallery,
    clipstore_broadcaster_reducer_add_gallery:reducer_add_gallery,
    clipstore_broadcaster_reducer_edit_gallery:reducer_edit_gallery,
    clipstore_broadcaster_reducer_delete_gallery:reducer_delete_gallery,

    get_content_list:reducer_get_content_list,
    get_picture_details:reducer_get_picture_details,
    get_video_details:reducer_get_video_details,
    get_gallery_details:reducer_get_gallery_details,

    purchase_content: reducer_purchase_content,
    subscribe_to_broadcaster: reducer_subscribe_to_broadcaster,

    get_subscription_list: reducer_get_subscription_list,
    cancel_subscription: reducer_cancel_subscription,
    renew_subscription: reducer_renew_subscription,

    get_my_subscribers: reducer_get_my_subscribers,
    get_my_subscription: reducer_get_my_subscription,
    update_my_subscription: reducer_update_my_subscription,
    get_all_users: reducer_get_all_users,
    post_content_in_chat: reducer_post_content_in_chat,
    get_chat_post:reducer_get_chat_post,
    buy_chat_post_content:reducer_buy_chat_post_content,

    user_profile_other:reducer_user_profile,
    user_following_other:reducer_user_following,

    get_comments:reducer_get_comments,
    create_comment:reducer_create_comment,
    update_comment:reducer_update_comment,
    delete_comment:reducer_delete_comment,

    get_reply:reducer_get_reply,
    create_reply:reducer_create_reply,
    update_reply:reducer_update_reply,
    delete_reply:reducer_delete_reply,

    form: formReducer
})

export default rootReducer;